__turbopack_context__.v({
  "store-stock-info__product-available": "store-stock-info-component-module-scss-module__2KiY5G__store-stock-info__product-available",
  "store-stock-info__product-unavailable": "store-stock-info-component-module-scss-module__2KiY5G__store-stock-info__product-unavailable",
});
